export default {
  isLoggedIn: state => state.isLoggedIn,
  isLoading: state => state.isLoading,
  error: state => state.error
}
